<template>
  <div class="test-menu__buttons">
    <AuButton
      v-for="(page, index) in pages"
      :key="index"
      :active="(index == currentPageIndex)"
      :hovered-bg-color="hovered"
      :active-color="active"
      border-color="true"
      font-size="16px"
      width="100%"
      @click="setCurrentPage(index)"
    >
      <span class="menu-items">
        {{ page }}
      </span>
    </AuButton>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      currentPageIndex: "testPage/currentPageIndex",
      pages: "testPage/pages",
      isLightTheme: "isLightTheme"
    }),

    hovered() {
      return this.isLightTheme ? "#1F3A43" : "#28282d";
    },

    active() {
      return this.isLightTheme ? "#1F3A43A3" : "#28282dA3";
    }
  },

  methods: {
    ...mapActions({
      setCurrentPage: "testPage/setCurrentPage"
    })
  }
};
</script>

<style lang="scss">
.test-menu__buttons {
  display: flex;
  flex-direction: column;
  gap: 2px;

  .menu-items {
    color: white !important;
  }
}
</style>